import { QuestionnaireType } from "@/encounters/components/EncounterLabor/constants/labor-questionnaires";

interface ApplyLaborQuickAddBirthCallbacksParams {
  questionnaireName: QuestionnaireType | string;
  normalizedValues: Record<string, unknown>;
  onBirthCreate?: (birthDateTime: string) => void;
  triggerBirthRefresh: () => void;
}

/** Applies optimistic birth Redux updates for birthing / shoulder-dystocia quick-adds. */
export function applyLaborQuickAddBirthCallbacks({
  questionnaireName,
  normalizedValues,
  onBirthCreate,
  triggerBirthRefresh,
}: ApplyLaborQuickAddBirthCallbacksParams): void {
  if (!onBirthCreate) {
    return;
  }

  if (questionnaireName === QuestionnaireType.Birthing) {
    const { birthingBodyDateTime } = normalizedValues;
    if (typeof birthingBodyDateTime === "string") {
      onBirthCreate(birthingBodyDateTime);
      triggerBirthRefresh();
    }
    return;
  }

  if (questionnaireName === QuestionnaireType.ShoulderDystocia) {
    const shoulderBirth = normalizedValues.shoulderDystociaBirth;
    if (typeof shoulderBirth === "string") {
      onBirthCreate(shoulderBirth);
      triggerBirthRefresh();
    }
  }
}
